import photos from './photos'

import logo1 from './logo1'

export default {
  backgroundImage: photos, // yarn makeBackgroundJson
  corpLogo: [
    logo1,
  ]
}